import request from '@/utils/request'

export function search(data, callback, error) {
  return request({
    url: '/index.php?m=signup&f=Search',
    method: 'post',
    data
  }).then(res => {
    callback(res)
  }).catch(res => {
    error(res)
  })
}

export function getInTime(callback) {
  return request({
    url: '/index.php?m=signup&f=GetInTime',
    method: 'get',
  }).then(res => {
    callback(res)
  })
}
